import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {Calendar, momentLocalizer} from 'react-big-calendar'
import {HeaderToolbar} from "../../components/CalendarEvents/HeaderToolbar/HeaderToolbar";
import moment from 'moment'
import {useCalendarEventsStore} from "../../store/CalendarEventsStore";
import {CalendarEventCreateSerializer} from "../../serializers/CalendarEventCreateSerializer";
import {EventItem} from "../../components/CalendarEvents/EventItem/EventItem";
import useDialog from "../../hooks/useDialog";
import CalendarEventUpdateForm from "../../components/CalendarEvents/CalendarEventUpdate/CalendarEventUpdateForm";
import CalendarEventCreateForm from "../../components/CalendarEvents/CalendarEventCreate/CalendarEventCreateForm";
import "react-big-calendar/lib/css/react-big-calendar.css"
import styles from "./index.module.css"

const localizer = momentLocalizer(moment)

const formats = {
    weekdayFormat: (date, culture, localizer) => localizer.format(date, 'dddd', culture),
}

const eventStyleGetter = () => {
    return {
        style: {
            backgroundColor : 'transparent',
        },
    };
};

function EventCalendar() {
    const {events, setEvents} = useCalendarEventsStore();
    const eventCreateDialog = useDialog();
    const eventUpdateDialog = useDialog();
    const eventCreateForm = useForm();
    const eventUpdateForm = useForm();

    const components = useMemo(() => ({
        event: EventItem,
        toolbar: (toolbarProps) =>
            <HeaderToolbar
                {...toolbarProps}
                handleOpen={eventCreateDialog.handleOpen}

            />,
    }), [])

    const handleSelectEvent = useCallback((e) => {
        eventUpdateDialog.handleOpen()
        eventUpdateForm.reset(e)
    },[])

    const handleSelectSlot = useCallback((slotInfo) => {
        eventCreateForm.setValue('date', moment(slotInfo.start).format('YYYY-MM-DD'))
        eventCreateDialog.handleOpen()
    }, [])

    const onSubmit = (formValues) => {
        eventCreateForm.reset()
        setEvents(CalendarEventCreateSerializer(formValues))
        eventCreateDialog.handleClose()
    }

    return (
        <div className={styles.calendar}>
            <Calendar
                localizer={localizer}
                events={events}
                formats={formats}
                startAccessor="start"
                endAccessor="end"
                views={['month']}
                components={components}
                onSelectEvent={handleSelectEvent}
                eventPropGetter={eventStyleGetter}
                onSelectSlot={handleSelectSlot}
                selectable
                popup={true}
                style={{height: 600}}
            />

            <CalendarEventUpdateForm
                open={eventUpdateDialog.open}
                register={eventUpdateForm.register}
                handleClose={eventUpdateDialog.handleClose}
            />

            <CalendarEventCreateForm
                open={eventCreateDialog.open}
                handleClose={eventCreateDialog.handleClose}
                handleSubmit={eventCreateForm.handleSubmit(onSubmit)}
                register={eventCreateForm.register}
            />
        </div>
    )
}

export default EventCalendar;